import { Injectable } from '@angular/core';
import { CompanyService } from '@core/services/company.service';
import { combineLatest, filter, map, Observable, switchMap } from 'rxjs';
import { ChatInputVisibilityService } from 'src/app/modules/live-chat/components/chat-input/chat-input-visibility.service';
import { InputStateVisibility } from 'src/app/modules/live-chat/interfaces/input-state-visibility.enum';
import { LiveChatStateService } from 'src/app/modules/live-chat/services/live-chat-state.service';

@Injectable({
  providedIn: 'root',
})
export class SharedApplicationStateService {
  constructor(
    private companyService: CompanyService,
    private livechatState: LiveChatStateService,
    private visibility: ChatInputVisibilityService
  ) {}

  canQuote$(): Observable<{ state: InputStateVisibility}> {
    return combineLatest([
      this.livechatState.listenCurrentAttendance$.pipe(
        filter(Boolean),
        filter(attendance => !!attendance.currentContactChannel)
      ),
      this.companyService.isLoading$
    ]).pipe(
      switchMap(([attendance, isLoading]) =>
        this.visibility.determineTextInputState$(attendance).pipe(
          map(state => {
            if (isLoading) {
              return {
                state: InputStateVisibility.COMPANY_LOADING,
              };
            }
            return {state: state.inputState};
          })
        )
      ),
    );
  }
}
